export default __webpack_public_path__ + "base-osm-800-1e5d903b3b21e1206d7d87a235550f56.webp";